import { useStore } from "../../../../store";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMySessions } from "src/store/session";
import { MyClassCard, MyClassCardSkeleton } from "../MyClassCard";
import EmptySessionCard from "../emptySessionsCard";

export default function MyCompletedClasses() {
  const { userStore } = useStore();
  const navigate = useNavigate();
  const [iscompletedClassesLoading, setIscompletedClassesLoading] =
    useState<boolean>(true);
  const [allcompletedClasses, setAllcompletedClasses] = useState<any[]>([]);
  const [completedClasses, setcompletedClasses] = useState<any[]>([]);
  const [pagesNumber, setPagesNumber] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(4);

  useEffect(() => {
    userStore.getUser().then(() => {
      const user = userStore.user;
      if (!user) {
        navigate("/login");
      }
    });
  }, []);

  const user = userStore.user;

  useEffect(() => {
    getMySessions(user?.id, itemsPerPage, itemsPerPage * pagesNumber, 3)
      .then((completedSessions) => {
        if (completedSessions) {
          if (
            completedSessions.sessions &&
            completedSessions.sessions.length > 0
          ) {
            setPagesNumber(
              Math.ceil(completedSessions.sessions.length / itemsPerPage)
            );
            setAllcompletedClasses(
              completedSessions.sessions.completedSessions
            );
            setcompletedClasses(
              completedSessions.sessions.slice(0, itemsPerPage)
            );
          } else {
            setAllcompletedClasses([]);
            setcompletedClasses([]);
            setPagesNumber(1);
          }
          setIscompletedClassesLoading(false);
        } else {
          setIscompletedClassesLoading(false);
        }
      })
      .catch((error) => {
        console.log("errorrr", error);
        setIscompletedClassesLoading(false);
      });
  }, []);

  return (
    <>
      {iscompletedClassesLoading && (
        <div className="w-full flex flex-col justify-start items-start space-y-[14px]">
          {/* completed classes list filter button */}
          <div className="w-full flex justify-end items-center">
            <div className="h-[24px] w-[148px] rounded-md"></div>
          </div>
          {/* completed classes list */}
          <div className="w-full flex flex-col justify-start items-start space-y-[8px] p-[14px] border border-[#DFDFDF] rounded-[20px]">
            {Array(3)
              .fill(null)
              .map((_, index) => (
                <MyClassCardSkeleton key={index} />
              ))}
          </div>
        </div>
      )}
      {!iscompletedClassesLoading && completedClasses.length > 0 && (
        <div className="w-full flex flex-col justify-start items-start space-y-[14px]">
          {/* completed classes list filter button */}
          <div className="w-full flex justify-end items-center">
            <button className="flex justify-center items-center space-x-[12px]">
              {/* filter icon */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.668 8.33301L1.66797 8.33301"
                  stroke="#E83C70"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.33203 11.667H1.66536"
                  stroke="#E83C70"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 15H1.66667"
                  stroke="#E83C70"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15 5L1.66667 5"
                  stroke="#E83C70"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.832 8.33366V16.667M15.832 16.667L18.332 14.167M15.832 16.667L13.332 14.167"
                  stroke="#E83C70"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {/* filter text */}
              <span className="text-[#E83C70] font-inter font-normal text-[14px] leading-[24px] ">
                Newest First
              </span>
            </button>
          </div>
          {/* completed classes list */}
          <div className="w-full flex flex-col justify-start items-start space-y-[8px] md:p-[14px] border border-[#DFDFDF] rounded-[20px]">
            {completedClasses.map((completedClass) => (
              <MyClassCard
                key={completedClass.id}
                classDetails={completedClass}
                classType="completed"
              />
            ))}
          </div>
        </div>
      )}
      {!iscompletedClassesLoading && completedClasses.length === 0 && (
        <EmptySessionCard />
      )}
    </>
  );
}
